import store from './index'
import Api from '@/api';

store.subscribe(function (mutation) {
    if (mutation.type == 'locale/SET_API_LOCALE') {
        Api.defaults.headers.common['Accept-Language'] = mutation.payload;
        try {
            store.dispatch('article/SET_ARTICLES', null)
            store.dispatch('article/SET_LOADED', false)
        } catch (e) {
            console.log(e)
        }
    }
});